import { PieceAction, UpdatePiecesRequest } from '@apiContract';

type ExplicitlyHandledProps = 'pieces' | 'action' | 'isForce' | 'shouldNotifyMailroom' | 'shouldNotifyRecipient';

type AdditionalData = Partial<Omit<UpdatePiecesRequest, ExplicitlyHandledProps>>;

interface BuildRequestDataParams {
  mailpieces: Array<{ id: number }>;
  action: PieceAction;
  isForce?: boolean;
  shouldNotifyMailroom?: boolean;
  shouldNotifyRecipient?: boolean;
  additionalData?: AdditionalData;
}

export const buildUpdatePiecesRequest = ({
  mailpieces,
  action,
  isForce,
  shouldNotifyMailroom,
  shouldNotifyRecipient,
  additionalData = {},
}: BuildRequestDataParams): UpdatePiecesRequest => {
  const requestData: UpdatePiecesRequest = {
    pieces: mailpieces.map((piece) => ({ id: Number(piece.id) })),
    action,
    isForce,
    ...(isForce && shouldNotifyMailroom !== undefined && { shouldNotifyMailroom }),
    ...(isForce && shouldNotifyRecipient !== undefined && { shouldNotifyRecipient }),
    ...additionalData,
  };

  return requestData;
};
